import { YWSINK_API } from '@/utils/http/baseUrl'
import b64md5 from './b64md5'
const md5StrLog = `weblog.gif CNx0u&xK!nHc^!Nnz&cz%K64Ms9gP8`
// http://ywsink-dev.vzan.com/usertrack.gif?md5=VasHD7i_VXzuAnryzsMsnw&expires=1
// echo -n '2147483647/usertrack.gif odPJHlx2it5CxyTY0pbCIRRQBdREPO' | openssl md5 -binary | openssl base64 | tr +/ -_ | tr -d =

export function webLog(data) {
  const now = Date.now()
  const date = Math.floor((now + 1200000000) / 1000)
  let str = `${date}/${md5StrLog}`
  str = b64md5(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
  return fetch(`${YWSINK_API}/weblog.gif?md5=${str}&expires=${date}`, {
    headers: {
      'content-type': 'text/plain'
    },
    body: encodeURIComponent(JSON.stringify(data)),
    method: 'POST',
    keepalive: true
  })
}
